module.exports = __webpack_public_path__ + "97a5bf17b910ecb1770518d576893b9c.fbx";